const Vue = require('vue');
const DragablePointUI = require('../../../ui/DragablePointUI');

Vue.component('draggable-router-ui', {
    props: {
        to: String,
        show: Boolean,
        eventLabel: String,
        initialorientation: String
    },
    template: require('../../../../../../../templates/ui/draggable-router-ui.pug'),
    computed: {
        orientation() {
            return this.initialorientation || 'y';
        }
    },
    mounted() {
        this.ui = new DragablePointUI(this.$el, this.orientation);
        // TODO: Resize if necessary
    },
    watch: {
        show(to) {
            if (to) this.ui.enable().show(1);
            else this.ui.hide();
        }
    },
    beforeDestroy() {
        if (!(this.$el.data && this.$el.data.uiController)) return;
        this.$el.data.uiController.destroy();
        // TODO: Stop resizing
    }
});
